import {
  fetchSuggestionsService,
  fetchLangstonSuggestionsService,
} from "./SearchMenu.services";
import { ISuggestion } from "./SearchMenu.constants";

export const fetchSuggestions = async ({
  fragment = "",
  isLangstonSuggestionsOn = false,
}: IFetchSuggestions) => {
  if (isLangstonSuggestionsOn) {
    const { results } = await fetchLangstonSuggestionsService(fragment);
    return results as string[];
  }

  const { results } = await fetchSuggestionsService(fragment);
  return results as ISuggestion[];
};

interface IFetchSuggestions {
  fragment?: string;
  isLangstonSuggestionsOn?: boolean;
}
